// @flow

import typeToReducer from 'type-to-reducer'
import { normalize } from 'normalizr'

import type { Categories } from '@alphaott/api-client/types/categories'
import type { CategoriesNormalize } from '@alphaott/common-types/normalized'

import { isValidTTL, calculateExpires } from '@alphaott/app-main/selectors'
import { categoriesListSchema } from '@alphaott/common-utils/utils/schemas/categories'
import { defaultToEmptyObject } from '@alphaott/common-utils/utils/help'
import { FETCH_MOVIE_CATEGORIES_TYPE } from '../../actions/categories'

export type MovieCategoriesState = {
  +isLoading: boolean,
  +isSuccess: boolean,
  +isError: boolean,
  +errors: any,
  +data: Categories,
  +entities: CategoriesNormalize,
  +expires: ?number,
}

const initialState: MovieCategoriesState = {
  isLoading: false,
  isSuccess: false,
  isError: false,
  errors: [],
  data: [],
  entities: {},
  expires: null,
}

const movieCategories = typeToReducer(
  {
    [FETCH_MOVIE_CATEGORIES_TYPE]: {
      LOADING: (state): MovieCategoriesState => ({ ...state, isLoading: true }),

      SUCCESS: (state, action): MovieCategoriesState => {
        const {
          payload,
          meta: { ttl },
        } = action
        const { entities } = normalize(payload.data, categoriesListSchema)
        return {
          ...state,
          isLoading: false,
          isSuccess: true,
          entities: defaultToEmptyObject(entities.categories),
          data: payload.data,
          ...(isValidTTL(ttl) && { expires: calculateExpires(ttl) }),
        }
      },

      ERROR: (state, action): MovieCategoriesState => ({
        ...state,
        isLoading: false,
        isSuccess: false,
        isError: true,
        errors: action.payload.error,
        expires: null,
      }),
    },
  },
  initialState,
)

export { movieCategories }
